import moment from 'moment';

// Canonical display formats — e.g. "Jul 4, 2026" / "Jul 4, 2026 4:00PM".
const DATE_ONLY_FORMAT = 'MMM D, YYYY';
const DATE_TIME_FORMAT = 'MMM D, YYYY h:mmA';

export function formatDateOnly(date) {
    if (date === null || date === undefined || date === '') return '—';
    const m = moment(date);
    return m.isValid() ? m.format(DATE_ONLY_FORMAT) : String(date);
}

export function formatDateTime(date) {
    if (date === null || date === undefined || date === '') return '—';
    const m = moment(date);
    return m.isValid() ? m.format(DATE_TIME_FORMAT) : String(date);
}

// Back-compat alias: existing call sites expect a date-only display string.
export const formatDate = formatDateOnly;

export function formatDateLine(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function formatDateLineTime(date) {
    if (!date || date === '—') return date || '—';

    var d = new Date(date);
    if (Number.isNaN(d.getTime())) return String(date);

    var month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minutes = '' + d.getMinutes(),
        seconds = '' + d.getSeconds();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (minutes.length < 2) minutes = '0' + minutes;
    if (seconds.length < 2) seconds = '0' + seconds;

    return `${[year, month, day].join('-')}\u2003\u2003${[hour, minutes, seconds].join(':')}`;
}

export function capitalizeWord(value) {
    if (value == null || value === '' || value === '—') return value || '—';
    const str = String(value).trim();
    if (!str) return '—';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}